/**
 * Get capitalized version of string value
 * @param {*} value The user fullname
 * @returns Capitalized string
 */
function capitalize(value) {
  let newValue = value.toLowerCase()
  newValue.replace(/\b\w/g, match => match.toUpperCase())
  return newValue
}
// function capitalizeText(inputText) {
//   // return inputText.replace(/\b\w/g, match => match.toUpperCase())
//   return inputText.replace(/(^|\s|['"`([{])\S/g, match => match.toUpperCase())
// }

function capitalizeText(inputText) {
  // Trim the input text to remove any leading or trailing spaces
  inputText = inputText.trim()
  // Capitalize the first letter and leave the rest of the text as it is
  return inputText.charAt(0).toUpperCase() + inputText.slice(1).toLowerCase()
}

/**
 * Get initials from user's fullname
 * @param {*} fullname The user fullname
 * @returns The name's initials
 */
function initials(fullname) {
  if (fullname.indexOf(" ") < 0) return fullname[0]?.toUpperCase() ?? ""
  return (
    fullname.split(" ")[0]?.charAt(0)?.toUpperCase() +
    fullname.split(" ")[1]?.charAt(0)?.toUpperCase()
  ).trim()
}

/**
 * Truncate string to specified size. Add "..." if string is truncated
 * @param {*} str The string to truncate
 * @returns The truncated string
 */
function limit(str, size) {
  if (str && str.length > size) return str.slice(0, size) + "..."
  return str
}

/**
 * Slugify method similar to django.utils.text.slugify method in Python
 * @param {*} str The string to slugify
 * @returns The slugified string
 */
function slugify(str) {
  let value = str.normalize("NFKD").toLocaleLowerCase()
  value = value.replaceAll(/[^\w\s-]/g, "")
  value = value.replaceAll(/[-\s]+/g, "-")
  return value.trim("-_").replace(/^-+|-+$/g, "")
}

/**
 * Check if the keypress is a number
 * @param {*} event Keypress event
 * @returns Boolean
 */
function isNumber(event) {
  event = event ? event : window.event
  let charCode = event.which ? event.which : event.keyCode
  if (charCode >= 48 && charCode <= 57) {
    return true
  } else {
    event.preventDefault()
  }
}

export { capitalize, initials, isNumber, limit, slugify, capitalizeText }
